document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-collection-page-size]');

  if (!selector) return;

  const url = new URL(window.location.href);
  const view = selector.value;

  if (view) {
    url.searchParams.set('view', view);
  } else {
    url.searchParams.delete('view');
  }

  url.searchParams.delete('page');
  window.location.assign(url.toString());
});
